<template>
  <div class="">
    <el-form :model="form" :rules="rules" ref="form">
      <TopBarTitleComponent title="Nueva Cotización" :showBackIcon="true">
        <template slot="right-area">
          <div class="d-flex justify-content-end align-items-center">
            <ButtonPrimaryComponent
              title="Guardar"
              @onSaveClick="handleSaveClick"
            />
          </div>
        </template>
      </TopBarTitleComponent>
      <b-container fluid class="pb-4 px-lg-4 pt-4">
        <b-row>
          <b-col>
            <div class="card box-shadow">
              <div class="card-body">
                <b-row>
                  <b-col xs="12" sm="12" md="12">
                    <el-form-item prop="name" class="mb-4">
                      <el-input
                        placeholder="Nombre de tu cotización"
                        v-model="form.name"
                        autocomplete="none"
                        id="input-text-top-bar"
                        class="h2 font-semi-bold"
                      ></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xs="12" sm="12" md="3">
                    <el-form-item prop="user_business_client_id">
                      <SelectBusinessComponent
                        @onChangeSelect="onChangeSelectBusiness"
                      />
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="12" md="3">
                    <el-form-item prop="user_business_client_contact_id">
                      <slot name="label">
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <label class="font-semi-bold m-0">Nombre</label>
                          <LinkPlus
                            onlyIcon
                            @onClick="onAddBusinnesClientContact"
                            v-if="form.user_business_client_id"
                          />
                        </div>
                      </slot>
                      <el-select
                        filterable
                        v-model="form.user_business_client_contact_id"
                        placeholder="Seleccionar"
                      >
                        <el-option
                          v-for="contact in client_contacts"
                          :key="contact.id"
                          :label="contact.name"
                          :value="contact.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="12" md="3">
                    <InputDatePickerComponent
                      @onChangeDatePicker="
                        date => onChangeDatePicker(date, 'date_at')
                      "
                      prop="date_at"
                      placeholder=""
                      title="Fecha de emisión"
                      :setDate="form.date_at"
                    />
                  </b-col>
                  <b-col xs="12" sm="12" md="3">
                    <InputDatePickerComponent
                      @onChangeDatePicker="
                        date => onChangeDatePicker(date, 'validate_at')
                      "
                      prop="validate_at"
                      placeholder=""
                      title="Validez Cotización"
                      :setDate="form.validate_at"
                    />
                  </b-col>
                  <!-- <b-col xs="12" sm="12" md="6">
                    <b-row>
                      <b-col xs="12" sm="12" md="6">
                        <el-form-item prop="user_business_client_id">
                          <SelectBusinessComponent
                            @onChangeSelect="onChangeSelectBusiness"
                          />
                        </el-form-item>
                      </b-col>
                      <b-col xs="12" sm="12" md="6">
                        <el-form-item prop="user_business_client_contact_id">
                          <slot name="label">
                            <label class="font-semi-bold m-0">Nombre</label>
                          </slot>
                          <el-select
                            filterable
                            v-model="form.user_business_client_contact_id"
                            placeholder="Seleccionar"
                          >
                            <el-option
                              v-for="contact in client_contacts"
                              :key="contact.id"
                              :label="contact.name"
                              :value="contact.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col xs="12" sm="12" md="6">
                        <InputDatePickerComponent
                          @onChangeDatePicker="
                            date => onChangeDatePicker(date, 'date_at')
                          "
                          prop="date_at"
                          placeholder=""
                          title="Fecha de emisión"
                          :setDate="form.date_at"
                        />
                      </b-col>
                      <b-col xs="12" sm="12" md="6">
                        <InputDatePickerComponent
                          @onChangeDatePicker="
                            date => onChangeDatePicker(date, 'validate_at')
                          "
                          prop="validate_at"
                          placeholder=""
                          title="Validez Cotización"
                          :setDate="form.validate_at"
                        />
                      </b-col>
                    </b-row>
                  </b-col> -->
                  <!-- <b-col xs="12" sm="12" md="6">
                    <el-form-item prop="city_id">
                      <slot name="label">
                        <label class="font-semi-bold m-0">Ciudad</label>
                      </slot>
                      <el-select
                        filterable
                        v-model="form.city_id"
                        placeholder="Seleccionar"
                      >
                        <el-option
                          v-for="city in cities"
                          :key="city.id"
                          :label="city.name"
                          :value="city.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col> -->
                </b-row>
                <TableInputProducts
                  @onToogleProducts="onToogleProducts"
                  :setProducts="form.products"
                  :hideTotal="form.hide_total"
                />
                <section class="aditional-quotes mt-4">
                  <b-row class="quote-bottom-row">
                    <b-col
                      xs="12"
                      sm="12"
                      md="4"
                      class="mb-3 mb-md-0 ml-md-auto order-1 order-md-2"
                    >
                      <DocumentCalculator
                        :setProducts="form.products"
                        :setHideTotal="form.hide_total"
                        allowTaxToggle
                        allowHideTotalToggle
                        @onChangeSwitchDiscount="onChangeSwitchDiscount"
                        @onChangeSwitchTaxt="onChangeSwitchTaxt"
                        @onChangeSwitchHideTotal="onChangeSwitchHideTotal"
                        @onTotalChange="onCalcTotalChange"
                      />
                    </b-col>
                    <b-col xs="12" sm="12" md="6" class="order-2 order-md-1">
                      <el-form-item prop="additional_specifications">
                        <slot name="label">
                          <label class="font-semi-bold m-0">
                            Especificaciones adicionales
                          </label>
                        </slot>

                        <ButtonPlusComponent
                          @onButtonPlusClick="
                            handleSaveAdditionalSpecifications
                          "
                        />

                        <b-row
                          class="my-4"
                          v-for="(specification,
                          index) in form.additional_specifications"
                          :key="index"
                        >
                          <b-col xs="10" sm="11" md="11">
                            <el-form-item
                              :prop="'additional_specifications.' + index"
                              :rules.sync="
                                getSyncRules && getSyncRules.rules.required()
                              "
                            >
                              <el-input
                                v-model="form.additional_specifications[index]"
                                type="text"
                                placeholder="Escriba el detalle"
                              ></el-input>
                            </el-form-item>
                          </b-col>
                          <b-col xs="2" sm="1" md="1">
                            <ButtonIcoComponent
                              class="float-right"
                              @onClick="removeAdditionalSpecifications(index)"
                            />
                          </b-col>
                        </b-row>
                      </el-form-item>

                      <div class="payment-conditions-card">
                        <div class="payment-section-header">
                          <i class="el-icon-wallet"></i>
                          <span>Condiciones de pago</span>
                        </div>

                        <el-radio-group
                          v-model="form.method_payment"
                          class="payment-radio-group"
                        >
                          <el-radio-button :label="1"
                            >De contado</el-radio-button
                          >
                          <el-radio-button :label="2">Crédito</el-radio-button>
                          <el-radio-button :label="3" :disabled="form.hide_total"
                            >Anticipo</el-radio-button
                          >
                        </el-radio-group>
                        <p
                          v-if="form.hide_total"
                          class="m-0 mt-2 text-muted hide-total-payment-hint"
                        >
                          El modo sin total (+IVA) no admite anticipo ni cuotas.
                        </p>

                        <transition name="slide-fade">
                          <div
                            v-if="form.method_payment === 1"
                            class="panel-contado"
                            key="contado"
                          >
                            <i class="el-icon-success"></i>
                            Pago inmediato al aprobar la cotización.
                          </div>
                        </transition>

                        <transition name="slide-fade">
                          <div
                            v-if="form.method_payment === 2"
                            class="panel-credito"
                            key="credito"
                          >
                            <b-row>
                              <b-col xs="12" sm="6" md="6">
                                <label class="field-label"
                                  >Plazo de crédito</label
                                >
                                <el-select
                                  v-model="form.limit_credit"
                                  placeholder="Seleccionar plazo"
                                  size="small"
                                >
                                  <el-option
                                    v-for="(limit, index) in limitCredits"
                                    :key="index"
                                    :label="limit.label"
                                    :value="limit.value"
                                  ></el-option>
                                </el-select>
                              </b-col>
                              <b-col xs="12" sm="6" md="6">
                                <InputDatePickerComponent
                                  @onChangeDatePicker="
                                    date =>
                                      onChangeDatePicker(
                                        date,
                                        'limit_credit_at'
                                      )
                                  "
                                  prop="limit_credit_at"
                                  placeholder=""
                                  title="Fecha de vencimiento"
                                  :setDate="form.limit_credit_at"
                                  v-if="form.limit_credit === 'others'"
                                />
                              </b-col>
                            </b-row>
                          </div>
                        </transition>

                        <transition name="slide-fade">
                          <div
                            v-if="form.method_payment === 3"
                            class="panel-anticipo"
                            key="anticipo"
                          >
                            <label class="field-label">Observaciones</label>
                            <el-input
                              v-model="form.observation_advance"
                              type="textarea"
                              :rows="2"
                              placeholder="Ej: 60% al inicio, 40% contra entrega del proyecto..."
                              size="small"
                              class="mb-3"
                            ></el-input>

                            <!-- Cuotas de pago -->
                            <div class="installments-section mt-3">
                              <div class="installments-header">
                                <span class="field-label m-0">
                                  <i class="el-icon-s-grid"></i> Cuotas de pago
                                </span>
                                <span
                                  :class="
                                    totalPercentage === 100
                                      ? 'pct-ok'
                                      : 'pct-warn'
                                  "
                                  class="pct-badge"
                                >
                                  {{ totalPercentage }}%
                                </span>
                              </div>

                              <div class="quick-tpl">
                                <button
                                  type="button"
                                  v-for="tpl in quickTemplates"
                                  :key="tpl.key"
                                  :class="[
                                    'tpl-btn',
                                    { active: activeTpl === tpl.key }
                                  ]"
                                  @click="applyInstallmentTemplate(tpl.key)"
                                >
                                  {{ tpl.label }}
                                </button>
                                <button
                                  type="button"
                                  class="tpl-btn tpl-custom"
                                  @click="addInstallment"
                                >
                                  <i class="el-icon-plus"></i> Personalizar
                                </button>
                              </div>

                              <div
                                v-for="(inst, index) in installments"
                                :key="'inst-' + index"
                                class="inst-row"
                              >
                                <div class="inst-row-main">
                                  <div class="inst-field inst-label">
                                    <input
                                      type="text"
                                      class="form-control form-control-sm"
                                      v-model="installments[index].label"
                                      :placeholder="getInstallmentLabel(index)"
                                    />
                                  </div>
                                  <div class="inst-field inst-pct">
                                    <div class="pct-input-wrap">
                                      <input
                                        type="number"
                                        class="form-control form-control-sm"
                                        v-model.number="
                                          installments[index].percentage
                                        "
                                        min="1"
                                        max="100"
                                        @input="recalcInstallmentAmounts"
                                      />
                                      <span class="pct-symbol">%</span>
                                    </div>
                                  </div>
                                  <div class="inst-field inst-amount">
                                    <span class="amount-display">
                                      ${{ Number(inst.amount || 0).toFixed(2) }}
                                    </span>
                                  </div>
                                  <div class="inst-field inst-delete">
                                    <ButtonIcoComponent
                                      v-if="installments.length > 1"
                                      @onClick="removeInstallment(index)"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </transition>
                      </div>
                    </b-col>
                  </b-row>

                  <!-- Seguimiento automático -->
                  <b-row>
                    <b-col xs="12">
                      <QuoteFollowupComponent
                        :enableFollowup="form.enable_followup"
                        :reminderSequenceId="form.reminder_sequence_id"
                        @onChange="onFollowupChange"
                      />
                    </b-col>
                  </b-row>
                </section>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </el-form>
    <!-- dialog to add new contact -->
    <el-dialog
      :visible.sync="dialogAddContact"
      :fullscreen="false"
      :before-close="handleCloseContactAdd"
    >
      <AddContactComponent
        :business_client_id="form.user_business_client_id"
        :showBackIcon="false"
        v-if="dialogAddContact"
        @onSuccess="onSuccessContactAdd"
      />
    </el-dialog>
  </div>
</template>

<script>
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import TopBarTitleComponent from "../../../../components/TopBarTitle";
import ButtonPlusComponent from "../../../../components/ButtonPlus";
import ButtonIcoComponent from "../../../../components/ButtonIco";
import SelectBusinessComponent from "../../../../components/SelectBusinessV2";
import InputDatePickerComponent from "../../../../components/InputDatePicker";
import TableInputProducts from "../../../components/TableInputProducts";
import DocumentCalculator from "../../../components/DocumentCalculator";
import LinkPlus from "../../../../components/LinkPlus";
import AddContactComponent from "../components/AddContact";
import QuoteFollowupComponent from "../components/QuoteFollowup";

import moment from "moment";
import Validate from "@/assets/validate";
import CitiesServices from "@/services/CitiesServices";
import quoteService from "../services/quoteService";
import configService from "../../../../configurations/services/configService";
import { limitCredits } from "../assets/resources";

const DATE_AT = moment().format("YYYY-MM-DD");
const DATE_TO_AT = moment()
  .add(15, "days")
  .format("YYYY-MM-DD");

export default {
  name: "QuoteAddPage",
  data() {
    return {
      cities: [],
      client_contacts: [],
      limitCredits,
      form: {
        name: "",
        user_business_client_id: "",
        user_business_client_contact_id: "",
        date_at: DATE_AT,
        validate_at: DATE_TO_AT,
        city_id: "",
        discount: 0,
        discount_type: "",
        products: [],
        additional_specifications: [],
        method_payment: 1,
        limit_credit: "",
        limit_credit_at: "",
        observation_advance: "",
        isTax: true,
        hide_total: false,
        enable_followup: true,
        reminder_sequence_id: null
      },
      rules: {
        name: [Validate.rules.required()],
        user_business_client_id: [Validate.rules.required("change")],
        //user_business_client_contact_id: [Validate.rules.required("change")],
        date_at: [Validate.rules.required()],
        validate_at: [Validate.rules.required()],
        // city_id: [Validate.rules.required("change")],
        method_payment: [Validate.rules.required("change")],
        limit_credit: [Validate.rules.required("change")],
        limit_credit_at: [Validate.rules.required("change")],
        observation_advance: [Validate.rules.required()]
      },
      dialogAddContact: false,
      quickTemplates: [
        { key: "60-40", label: "60 / 40" },
        { key: "50-50", label: "50 / 50" },
        { key: "40-30-30", label: "40 / 30 / 30" }
      ],
      activeTpl: "60-40",
      installments: [
        { label: "Anticipo", percentage: 60, amount: 0, sort_order: 0 },
        { label: "Entrega final", percentage: 40, amount: 0, sort_order: 1 }
      ],
      quoteTotal: 0
    };
  },
  computed: {
    getSyncRules() {
      return Validate;
    },
    totalPercentage() {
      return this.installments.reduce(
        (sum, i) => sum + (Number(i.percentage) || 0),
        0
      );
    }
  },
  methods: {
    // ─── Installment methods ───
    applyInstallmentTemplate(key) {
      this.activeTpl = key;
      const templates = {
        "60-40": [
          { l: "Anticipo", p: 60 },
          { l: "Entrega final", p: 40 }
        ],
        "50-50": [
          { l: "Primera cuota", p: 50 },
          { l: "Segunda cuota", p: 50 }
        ],
        "40-30-30": [
          { l: "Anticipo", p: 40 },
          { l: "Segunda cuota", p: 30 },
          { l: "Entrega final", p: 30 }
        ]
      };
      const tpl = templates[key] || templates["60-40"];
      this.installments = tpl.map((item, i) => ({
        label: item.l,
        percentage: item.p,
        amount: +(this.quoteTotal * (item.p / 100)).toFixed(2),
        sort_order: i
      }));
    },
    addInstallment() {
      this.activeTpl = "";
      this.installments.push({
        label: "",
        percentage: 0,
        amount: 0,
        sort_order: this.installments.length
      });
    },
    removeInstallment(index) {
      this.activeTpl = "";
      this.installments.splice(index, 1);
      this.installments.forEach((inst, i) => (inst.sort_order = i));
      this.recalcInstallmentAmounts();
    },
    recalcInstallmentAmounts() {
      this.installments.forEach(inst => {
        inst.amount = +(
          this.quoteTotal *
          ((inst.percentage || 0) / 100)
        ).toFixed(2);
      });
    },
    getInstallmentLabel(index) {
      return (
        ["Anticipo", "Segunda cuota", "Tercera cuota", "Cuota final"][index] ||
        "Cuota " + (index + 1)
      );
    },
    async loadGlobalSpecs() {
      try {
        const response = await configService.getUserConfigTexts();
        const specs =
          response.data &&
          response.data.data &&
          response.data.data.additional_specifications;
        if (
          specs &&
          specs.length &&
          !this.form.additional_specifications.length
        ) {
          this.form.additional_specifications = [...specs];
        }
      } catch (e) {
        // silently fail — specs are optional
      }
    },
    handleSaveAdditionalSpecifications() {
      this.form.additional_specifications.push("");
    },
    removeAdditionalSpecifications(index) {
      this.form.additional_specifications.splice(index, 1);
    },
    onChangeDatePicker({ date }, property) {
      this.form[property] = date;
    },
    onToogleProducts({ products }) {
      this.form.products = [...products];
    },
    onChangeSelectBusiness({ client }) {
      const { id, contacts } = client;
      this.form.user_business_client_id = id;
      this.client_contacts = contacts;
      this.handleResetFormInput("user_business_client_contact_id");
    },
    onCalcTotalChange(total) {
      this.quoteTotal = total;
      this.recalcInstallmentAmounts();
    },
    onChangeSwitchDiscount({ discount, type }) {
      this.form.discount = discount;
      this.form.discount_type = type;
    },
    onChangeSwitchTaxt({ value }) {
      this.form.isTax = value;
    },
    onChangeSwitchHideTotal({ value }) {
      this.form.hide_total = !!value;
      if (this.form.hide_total) {
        this.form.discount = 0;
        if (this.form.method_payment === 3) {
          this.form.method_payment = 1;
          this.$notifications.warning({
            message:
              "El modo sin total (+IVA) no admite anticipo ni cuotas. La forma de pago cambió a De contado."
          });
        }
      }
    },
    onValidateFormProducts() {
      return this.form.products.length >= 1 ? true : false;
    },
    handleSaveClick() {
      if (!this.onValidateFormProducts()) {
        const message = "Debe agregar productos a la cotización.";
        this.$notifications.error({ message });
        return;
      }
      if (this.form.hide_total && this.form.method_payment === 3) {
        this.$notifications.error({
          message:
            "El modo sin total (+IVA) no admite anticipo ni cuotas. Cambia la forma de pago o desactiva el modo."
        });
        return;
      }

      this.$refs.form.validate(async valid => {
        if (valid) {
          this.$store.dispatch("toggleRequestLoading");
          try {
            const payload = { ...this.form };
            if (this.form.method_payment === 3 && this.installments.length) {
              this.recalcInstallmentAmounts();
              var lines = [];
              if (this.form.observation_advance) {
                lines.push(this.form.observation_advance);
                lines.push("");
              }
              lines.push("Detalle de cuotas:");
              this.installments.forEach(function(inst) {
                lines.push(
                  "- " +
                    inst.label +
                    ": " +
                    inst.percentage +
                    "% — $" +
                    inst.amount.toFixed(2)
                );
              });
              payload.observation_advance = lines.join("\n");
            }
            let response = await quoteService.addQuotes(payload).finally(() => {
              this.$store.dispatch("toggleRequestLoading");
            });

            const { success, data } = response.data;
            if (success) {
              const { user_business_quote_id, user_business_quote_v_id } = data;

              // Sync installments to dedicated table (silent — does not block save)
              if (this.form.method_payment === 3 && this.installments.length) {
                try {
                  await quoteService.syncInstallments(
                    user_business_quote_id,
                    user_business_quote_v_id,
                    this.installments.map((inst, i) => ({
                      label: inst.label,
                      percentage: inst.percentage,
                      sort_order: i
                    }))
                  );
                } catch (e) {
                  /* tabla puede no existir aún */
                }
              }

              this.$refs.form.resetFields();

              this.goRouter(
                "sales.quotes.view",
                {
                  id: user_business_quote_id,
                  idVersion: user_business_quote_v_id
                },
                {
                  quoteSendEmail: "success"
                }
              );
            }
          } catch (error) {
            return false;
          }
        }
      });
    },
    handleResetFormInput(input) {
      this.form[input] = "";
    },
    goRouter(name, params = {}, query = {}) {
      this.$router.push({ name, params, query });
    },
    async getCities() {
      await CitiesServices.getCities()
        .then(response => {
          if (response.data.success) this.cities = response.data.cities;
        })
        .catch(() => {});
    },
    /* dialog to add conctact */
    onSuccessContactAdd({ contact }) {
      this.client_contacts = [contact, ...this.client_contacts];
      this.form.user_business_client_contact_id = contact.id;
      this.dialogAddContact = false;
    },
    onAddBusinnesClientContact() {
      this.dialogAddContact = true;
    },
    onFollowupChange({ enableFollowup, reminderSequenceId }) {
      this.form.enable_followup = enableFollowup;
      this.form.reminder_sequence_id = reminderSequenceId;
    },
    handleCloseContactAdd() {
      this.dialogAddContact = false;
    }
  },
  components: {
    ButtonPrimaryComponent,
    TopBarTitleComponent,
    ButtonPlusComponent,
    ButtonIcoComponent,
    SelectBusinessComponent,
    InputDatePickerComponent,
    TableInputProducts,
    DocumentCalculator,
    AddContactComponent,
    LinkPlus,
    QuoteFollowupComponent
  },
  mounted() {
    if (this.$store.getters.getRequestLoading.active) {
      this.$store.dispatch("toggleRequestLoading");
    }
    this.getCities();
    this.loadGlobalSpecs();
  }
};
</script>

<style lang="sass">
.date-picker-quote
  .el-input__prefix
    right: 0px !important;
    left: auto;
.number-descount
  .el-input__inner
    min-height: 40px;
    width: 60px;

.el-autocomplete
  width: 100% !important;
.my-autocomplete
  li
    line-height: normal;
    padding: 7px;
    .value
      text-overflow: ellipsis;
      overflow: hidden;
    .link
      font-size: 12px;
      color: #b4b4b4;

.el-icon-delete
  font-size: 1.5rem;
</style>
